import { removeTheseProps } from '@/utils';
import {
  ListItemButton,
  ListItemButtonProps,
  ListItemText,
  ListItemTextProps,
  Popover,
  PopoverProps,
  Stack,
  styled,
} from '@mui/material';

export const StyledPopover = styled((props: PopoverProps) => (
  <Popover
    anchorOrigin={{
      vertical: 'bottom',
      horizontal: 'left',
    }}
    {...props}
  />
))({
  '& .MuiPaper-root': {
    marginTop: 4,
    borderRadius: 8,
    boxShadow: '0 2px 8px 0 rgba(78, 80, 84, 0.16)',
  },
});

export const PopoverContainer = styled(Stack)(({ theme: { palette } }) => ({
  minWidth: 145,
  maxWidth: 145,
  paddingBottom: 0,
  border: `1px solid ${palette.gray100.main}`,
  borderRadius: 16,
  backgroundColor: palette.common.white,
  overflow: 'hidden',
}));

type ItemButtonProps = ListItemButtonProps & {
  active?: boolean;
};

export const KebabItemButton = styled(
  (props: ItemButtonProps) => <ListItemButton disableGutters {...props} />,
  { shouldForwardProp: removeTheseProps<ItemButtonProps>('active') },
)<ItemButtonProps>(({ theme }) => {
  return {
    paddingLeft: 8,
    paddingRight: 8,
    backgroundColor: 'unset',
    transition: 'all 200ms',
    '&:hover': {
      backgroundColor: '#E8EAEC',
    },
    '& .MuiListItemText-primary': {
      color: theme.palette.blue.main,
      transition: 'all 200ms',
    },
    '& .MuiListItemIcon-root': {
      color: theme.palette.blue.main,
      transition: 'all 200ms',
    },
  };
});

type ItemTextProps = ListItemTextProps & {
  subListItem?: boolean;
};

export const KebabItemText = styled(ListItemText, {
  shouldForwardProp: removeTheseProps<ItemTextProps>('subListItem'),
})<ItemTextProps>(({ subListItem }) => ({
  '& .MuiListItemText-primary': {
    fontSize: subListItem ? 11 : 13,
    fontWeight: 400,
  },
}));
